import React, { useState, useContext } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { auth } from '../../firebase/firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { AuthContext } from '../AuthContext';

const ProfessorLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { currentUser, loading: authLoading } = useContext(AuthContext);

    // Show loading while auth is initializing
    if (authLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', color: '#666' }}>
                Loading...
            </div>
        );
    }

    // If already signed in, redirect to dashboard
    if (currentUser) {
        return <Navigate to="/professor-dashboard" replace />;
    }

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/professor-dashboard');
        } catch (err) {
            console.error('Professor login error:', err);
            if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
                setError('Invalid email or password.');
            } else {
                setError('Login failed. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            minHeight: '100vh', backgroundColor: '#f5f5f5', fontFamily: 'Arial, sans-serif',
        }}>
            <div style={{
                backgroundColor: '#fff', padding: '40px', borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)', maxWidth: '400px', width: '100%',
            }}>
                <h1 style={{ textAlign: 'center', color: '#4b2e83', marginBottom: '8px', fontSize: '24px' }}>
                    Instructor Login
                </h1>
                <p style={{ textAlign: 'center', color: '#666', marginBottom: '24px', fontSize: '14px' }}>
                    Sign in to access the instructor dashboard
                </p>

                <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                        style={{
                            padding: '12px', borderRadius: '6px', border: '1px solid #ddd',
                            fontSize: '14px', outline: 'none',
                        }}
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        required
                        style={{
                            padding: '12px', borderRadius: '6px', border: '1px solid #ddd',
                            fontSize: '14px', outline: 'none',
                        }}
                    />

                    {error && (
                        <p style={{ color: '#e15759', fontSize: '13px', margin: 0, textAlign: 'center' }}>
                            {error}
                        </p>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            padding: '12px', backgroundColor: '#4b2e83', color: '#fff',
                            border: 'none', borderRadius: '6px', fontSize: '16px',
                            fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.7 : 1,
                        }}
                    >
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>

                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <button
                        onClick={() => navigate('/professor-signup')}
                        style={{
                            background: 'none', border: 'none', color: '#4b2e83',
                            cursor: 'pointer', fontSize: '13px', textDecoration: 'underline',
                        }}
                    >
                        Create an instructor account
                    </button>
                </div>
                <div style={{ textAlign: 'center', marginTop: '8px' }}>
                    <button
                        onClick={() => navigate('/')}
                        style={{
                            background: 'none', border: 'none', color: '#4b2e83',
                            cursor: 'pointer', fontSize: '13px', textDecoration: 'underline',
                        }}
                    >
                        Back to Student Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProfessorLogin;
